module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp11-6d1fdb1baa5f3dd352d72e6ba91e2c53.jpg";